
import ArticlesList from "../components/articles/article-list";
import ContactForm from "../components/contact-page/contact-form";
import FounderResource from "../components/portfolio/founder-resources";
import Banner from "../components/ui-components/banner";
import HomePortfolio from "../components/ui-components/portfolio";
import { fetchContactPage } from "../services/api";
import SeoHead from '../components/SeoHead.jsx';
const ContactPage=({lang})=>{

    return(
        <>
         <SeoHead slug="contact" lang={lang} />
        <Banner  fetchData={fetchContactPage} lang={lang} />
        <ContactForm />
        </>
    )
}

export default ContactPage;